import { ROUTES } from '../../constants/routes';

const DEFAULT_TARGET = ROUTES.STANDARDISIERUNG;

/** Only allow internal, single-slash-rooted paths to prevent open redirects. */
export function safeRedirectTarget(param: string | null): string {
  if (param && param.startsWith('/') && !param.startsWith('//')) {
    return param;
  }
  return DEFAULT_TARGET;
}
